import React from 'react'

import { ReactComponent as BlueArrowIcon } from 'presentation/assets/icons/blue-back-arrow.svg'

import * as S from './styles'
import { DoctorRegisterStatus } from 'common/enum/doctor-register-status'

type Props = {
  status: DoctorRegisterStatus
}

const StatusIndicator = ({ status }: Props) => {
  const getSubTitleByStatus = (status: DoctorRegisterStatus): string => {
    if (status === DoctorRegisterStatus.REVIEWED_BY_DIRECTOR) {
      return 'DIR'
    }
    if (status === DoctorRegisterStatus.APPROVED_BY_DIRECTOR_WITH_PENDENCIES) {
      return 'DIR'
    }
    return ''
  }

  const getSubIconByStatus = (
    status: DoctorRegisterStatus
  ): React.ReactNode | undefined => {
    if (status === DoctorRegisterStatus.PENDENCY_ANSWERED) {
      return <BlueArrowIcon />
    }
    if (
      status === DoctorRegisterStatus.REGISTER_SEND_TO_DIRECTOR ||
      status === DoctorRegisterStatus.REGISTER_RESEND_TO_DIRECTOR
    ) {
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_12346_11719" fill="white">
            <path d="M14 -6.11959e-07C11.2311 -4.90925e-07 8.5243 0.821085 6.22202 2.35943C3.91973 3.89777 2.12531 6.08427 1.06569 8.64243C0.00605894 11.2006 -0.271188 14.0155 0.269006 16.7313C0.809199 19.447 2.14257 21.9416 4.1005 23.8995C6.05844 25.8574 8.553 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14L24.5183 14C24.5183 16.0803 23.9014 18.1139 22.7457 19.8437C21.5899 21.5734 19.9472 22.9216 18.0252 23.7177C16.1032 24.5138 13.9883 24.7221 11.948 24.3162C9.90762 23.9104 8.03343 22.9086 6.56241 21.4376C5.09139 19.9666 4.08962 18.0924 3.68377 16.052C3.27791 14.0117 3.48621 11.8968 4.28232 9.97481C5.07843 8.05283 6.42659 6.41009 8.15632 5.25432C9.88605 4.09855 11.9197 3.48166 14 3.48166L14 -6.11959e-07Z" />
          </mask>
          <path
            d="M14 -6.11959e-07C11.2311 -4.90925e-07 8.5243 0.821085 6.22202 2.35943C3.91973 3.89777 2.12531 6.08427 1.06569 8.64243C0.00605894 11.2006 -0.271188 14.0155 0.269006 16.7313C0.809199 19.447 2.14257 21.9416 4.1005 23.8995C6.05844 25.8574 8.553 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14L24.5183 14C24.5183 16.0803 23.9014 18.1139 22.7457 19.8437C21.5899 21.5734 19.9472 22.9216 18.0252 23.7177C16.1032 24.5138 13.9883 24.7221 11.948 24.3162C9.90762 23.9104 8.03343 22.9086 6.56241 21.4376C5.09139 19.9666 4.08962 18.0924 3.68377 16.052C3.27791 14.0117 3.48621 11.8968 4.28232 9.97481C5.07843 8.05283 6.42659 6.41009 8.15632 5.25432C9.88605 4.09855 11.9197 3.48166 14 3.48166L14 -6.11959e-07Z"
            stroke="#5ACA65"
            strokeWidth="48"
            mask="url(#path-1-inside-1_12346_11719)"
          />
        </svg>
      )
    }
    return undefined
  }

  return (
    <S.Wrapper doctorStatus={status}>
      <S.SubTitle>
        {getSubIconByStatus(status)
          ? getSubIconByStatus(status)
          : getSubTitleByStatus(status)}
      </S.SubTitle>
    </S.Wrapper>
  )
}

export default StatusIndicator
